/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-24 18:48:46
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { DtBrowserModule } from '@ithinkdt/shared/browser';

import { FeishuAccountComponent } from './feishu-account/feishu-account.component';
import { FeishuMenuComponent } from './feishu-menu/feishu-menu.component';
import { FeishuThemeComponent } from './feishu-theme.component';
import { FeishuSettingsComponent } from './feishu-user/feishu-settings/feishu-settings.component';
import { FeishuUserComponent } from './feishu-user/feishu-user.component';

const ANGULAR_MODULES = [CommonModule, FormsModule, ReactiveFormsModule, RouterModule];

const THIRD_MODULES = [TranslateModule];

const ANTD_MODULES = [
  NzAvatarModule,
  NzButtonModule,
  NzFormModule,
  NzIconModule,
  NzInputModule,
  NzLayoutModule,
  NzModalModule,
  NzPopoverModule,
  NzToolTipModule,
];

const DT_MODULES = [DtBrowserModule];

const COMPONENTS = [
  FeishuThemeComponent,
  FeishuAccountComponent,
  FeishuMenuComponent,
  FeishuUserComponent,
  FeishuSettingsComponent,
];

@NgModule({
  imports: [...ANGULAR_MODULES, ...THIRD_MODULES, ...ANTD_MODULES, ...DT_MODULES],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class DtFeishuThemeModule {}
